import React from "react"

import { useAuth } from "../../../auth/hooks"

import Link from "@components/elements/Link"
import ChevronIcon from "@components/elements/V2/Icons/ChevronIcon"
import KhumoIcon from "@components/elements/V2/Icons/KhumoIcon"
import SignOutIcon from "@components/elements/V2/Icons/SignOutIcon"
import StoreIcon from "@components/elements/V2/Icons/StoreIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { withAppBaseUrl } from "@utils/url"

const DashboardOptions = () => {
  const { signOut } = useAuth()

  return (
    <>
      <Link
        link={withAppBaseUrl("hub")}
        className="mt-1 flex [&_p]:hover:text-blue"
      >
        <StoreIcon className="mr-8" />
        <Typography
          text="Yoco Hub"
          size="body-md"
          font="grotesk"
          weight="book"
          color={Color.Black}
          className="mt-1"
        />
        <ChevronIcon className="ml-auto -rotate-90" />
      </Link>

      <Link
        link={withAppBaseUrl("manage")}
        className="mt-1 flex [&_p]:hover:text-blue"
      >
        <KhumoIcon className="mr-8" />
        <Typography
          text="Activate my card machine"
          size="body-md"
          font="grotesk"
          weight="book"
          color={Color.Black}
          className="mt-1"
        />
        <ChevronIcon className="ml-auto -rotate-90" />
      </Link>

      <div className="-mx-[30px] border-b border-gray" />

      <Link
        link=""
        onClick={signOut}
        className="mt-1 flex [&_p]:hover:text-blue"
      >
        <SignOutIcon className="mr-8" />
        <Typography
          text="Sign out"
          size="body-md"
          font="grotesk"
          weight="book"
          color={Color.Black}
          className="mt-1"
        />
        <ChevronIcon className="ml-auto -rotate-90" />
      </Link>
    </>
  )
}

export default DashboardOptions
